import type { ReactNode } from "react";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

interface FieldProps {
  id: string;
  label: ReactNode;
  hint?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** Label above the control, optional hint below. */
export function Field({ id, label, hint, children, className }: FieldProps) {
  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      <Label htmlFor={id}>{label}</Label>
      {children}
      {hint ? <p className="text-label text-muted-foreground">{hint}</p> : null}
    </div>
  );
}

/** Checkbox with its label to the right. */
export function CheckField({ id, label, checked, onChange, disabled }: { id: string; label: ReactNode; checked: boolean; onChange: (checked: boolean) => void; disabled?: boolean }) {
  return (
    <label htmlFor={id} className="flex items-center gap-2 text-body text-foreground">
      <input id={id} type="checkbox" className="size-4 accent-brand" checked={checked} disabled={disabled} onChange={(event) => onChange(event.target.checked)} />
      {label}
    </label>
  );
}
